declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { HCPService } from '../../../../services/hcp.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorPersonalInfoRequest, ActorPersonalInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { NgbPersonalInfoModal } from './modals/ngbpersonalinfo.modal';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

@Component({
  selector: 'personalinfo',
  templateUrl: './personalinfo.component.html',
  styleUrls: ['./personalinfo.component.scss']
})

export class PersonalInfoComponent implements OnInit {

  @Input() ActorCode: number;
  @Input() ActorType: number;

  @Input() CanEdit: number;
  @Input() CanShow: number;
  @Input() CanShowRegistryView: number;

  public isRequesting: boolean = false;
  CurrentActorPersonalInfoRequest: ActorPersonalInfoRequest;
  CurrentActorPersonalInfoController: ActorPersonalInfoController;

  public ApiResData: ApiResponseModel;


  //
  public key: ActorPersonalInfoController;

  @Input()
  get Key() {
    return this.key;
  }

  @Output() personalInfoChange = new EventEmitter();
  //set Key(value: ActorPersonalInfoController) {
  //  this.key = value;
  //  //  alertFunctions.AlertParam(this.Key);
  //  console.log('personalInfoChange');
  //  this.personalInfoChange.emit(this.key);
  //}
  //


  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService,
    private modalService: NgbModal) { }

  ngOnInit() {
    ////console.log('CanShow............' + this.CanShow);
    this.CurrentActorPersonalInfoRequest = new ActorPersonalInfoRequest();
    this.CurrentActorPersonalInfoController = new ActorPersonalInfoController();
    this.CurrentActorPersonalInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorPersonalInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    if (this.CanShow === 1 || this.CanShowRegistryView === 1) {
      this.GetActorPersonalInfoController();
    }
  
  }
  GetActorPersonalInfoController() {
    //  console.log(this.CurrentActorProfileRequest.SendApiRequestModel.xAuthGenKEY);
    this.StartRefreshing();
    this.hcpservice.GetActorPersonalInfoController(this.CurrentActorPersonalInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

     
          this.CurrentActorPersonalInfoController = this.ApiResData.Result[0];
          this.key = this.ApiResData.Result[0];
          this.personalInfoChange.emit(this.key);
         // console.log('this.personalInfoChange' + this.key.DisplayName);
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  OpenEditContent() {
    if (this.CanEdit === 1) {
      this.CurrentActorPersonalInfoRequest.ConditionalOperator = 2;
      this.CurrentActorPersonalInfoRequest.ActorCode = this.CurrentActorPersonalInfoController.ActorCode;
      this.CurrentActorPersonalInfoRequest.Salutation = this.CurrentActorPersonalInfoController.Salutation;
      this.CurrentActorPersonalInfoRequest.FirstName = this.CurrentActorPersonalInfoController.FirstName;
      this.CurrentActorPersonalInfoRequest.MiddleName = this.CurrentActorPersonalInfoController.MiddleName;
      this.CurrentActorPersonalInfoRequest.LastName = this.CurrentActorPersonalInfoController.LastName;
      this.CurrentActorPersonalInfoRequest.DisplayName = this.CurrentActorPersonalInfoController.DisplayName;
      this.CurrentActorPersonalInfoRequest.SocialSecurityNumber = this.CurrentActorPersonalInfoController.SocialSecurityNumber;
      this.CurrentActorPersonalInfoRequest.DateOfBirth = this.CurrentActorPersonalInfoController.DateOfBirth;
      this.CurrentActorPersonalInfoRequest.PlaceOfBirth = this.CurrentActorPersonalInfoController.PlaceOfBirth;
      this.CurrentActorPersonalInfoRequest.Gender = this.CurrentActorPersonalInfoController.Gender;
      this.CurrentActorPersonalInfoRequest.BloodGroup = this.CurrentActorPersonalInfoController.BloodGroup;
      this.CurrentActorPersonalInfoRequest.Nationality = this.CurrentActorPersonalInfoController.Nationality;
      this.CurrentActorPersonalInfoRequest.Religion = this.CurrentActorPersonalInfoController.Religion;
      this.CurrentActorPersonalInfoRequest.BirthIdentification1 = this.CurrentActorPersonalInfoController.BirthIdentification1;
      this.CurrentActorPersonalInfoRequest.BirthIdentification2 = this.CurrentActorPersonalInfoController.BirthIdentification2;
      this.CurrentActorPersonalInfoRequest.LiveIn = this.CurrentActorPersonalInfoController.LiveIn;
      this.CurrentActorPersonalInfoRequest.Occupation = this.CurrentActorPersonalInfoController.Occupation;
      this.CurrentActorPersonalInfoRequest.MaritalStatus = this.CurrentActorPersonalInfoController.MaritalStatus;
      this.CurrentActorPersonalInfoRequest.HasWorkPermit = this.CurrentActorPersonalInfoController.HasWorkPermit;
      this.CurrentActorPersonalInfoRequest.IsConvicted = this.CurrentActorPersonalInfoController.IsConvicted;
      this.CurrentActorPersonalInfoRequest.LanguagesSpoken = this.CurrentActorPersonalInfoController.LanguagesSpoken;
      this.CurrentActorPersonalInfoRequest.LanguagesRead = this.CurrentActorPersonalInfoController.LanguagesRead;

      const modalRef = this.modalService.open(NgbPersonalInfoModal)//.result(result => { this.GetActorProfileController();});
      modalRef.componentInstance.CurrentActorPersonalInfoRequest = this.CurrentActorPersonalInfoRequest;
      modalRef.result.then(x => { this.GetActorPersonalInfoController() })
    }
    else {
      alertFunctions.AlertParam('Access Denied  Please Contact Admin....!');
    }

  }


}
